import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import Breadcrumb from '../components/Breadcrumb';
import { services } from '../mock';
import * as LucideIcons from 'lucide-react';

const Leistungen = () => {
  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: 'Leistungen' }]} />
        
        <h1 className="text-4xl font-bold text-[#0F172A] mb-6">Unsere Leistungen in Dortmund</h1>
        <p className="text-lg text-gray-700 mb-12 max-w-3xl">
          Von der kompletten Haushaltsauflösung bis zur Entrümpelung einzelner Räume – 
          wir bieten alle Dienstleistungen rund um die professionelle Räumung in Dortmund. 
          Jede Leistung wird zum fairen Festpreis, besenrein und mit Wertanrechnung angeboten.
        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service) => {
            const IconComponent = LucideIcons[service.icon];
            return (
              <Card key={service.id} className="border-2 border-gray-100 hover:border-[#16A34A] hover:shadow-lg transition-all">
                <CardContent className="pt-8">
                  {IconComponent && <IconComponent className="h-12 w-12 text-[#16A34A] mb-4" />}
                  <h2 className="text-2xl font-semibold text-[#0F172A] mb-4">{service.title}</h2>
                  <p className="text-gray-700 mb-6 leading-relaxed">{service.description}</p>
                  
                  <div className="space-y-3 mb-6">
                    <div className="flex items-start gap-2">
                      <span className="text-[#16A34A] font-bold">✓</span>
                      <span className="text-sm text-gray-700">Festpreis nach Besichtigung oder Foto-Zusendung</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="text-[#16A34A] font-bold">✓</span>
                      <span className="text-sm text-gray-700">Besenreine Übergabe garantiert</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="text-[#16A34A] font-bold">✓</span>
                      <span className="text-sm text-gray-700">Wertanrechnung bei verwertbaren Gegenständen</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="text-[#16A34A] font-bold">✓</span>
                      <span className="text-sm text-gray-700">Gesetzeskonforme Entsorgung mit Nachweis</span>
                    </div>
                  </div>

                  <Button asChild className="w-full bg-[#16A34A] hover:bg-[#16A34A]/90 text-white">
                    <Link to={`/${service.slug}`}>Details & Preise</Link>
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 bg-gray-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Ihre Leistung nicht dabei?</h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Wir bieten auch individuelle Lösungen für besondere Anforderungen. 
            Kontaktieren Sie uns – wir finden eine passende Lösung für Ihr Projekt in Dortmund.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-[#16A34A] hover:bg-[#16A34A]/90 text-white">
              <Link to="/kontakt">Jetzt anfragen</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white">
              <a href="tel:+4923139085116">0231 39085116</a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leistungen;